export default function textRotation(shape, option) {
    shape.resetMatrix();
    shape.attr({
        rotate: 360 - option.degree,
        textAlign: 'right',
        textBaseline: 'middle',
    });
}
//# sourceMappingURL=text-rotation.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/util/responsive/rules/text-rotation.js
// module id = null
// module chunks = 